import { Tooltip } from 'components/overlay/Tooltip';
import { Icon } from 'components/elements/icon';
import { Highlight } from 'components/text/Highlight';

import * as styled from './styles/card';
import type { TooltipObject } from '../AvatarsGroup/types';

type CardSectionProps = {
  title?: string | React.ReactNode | null;
  tooltip?: TooltipObject;
  children: React.ReactNode[] | React.ReactNode;
};

export const CardSection = function CardSection({
  title = null,
  children,
  tooltip,
  ...props
}: CardSectionProps) {
  return (
    <styled.Section {...props}>
      {(title || tooltip) && (
        <styled.SectionTitle>
          {title || ''}

          {tooltip && (
            <styled.SectionTitleTooltip>
              <Tooltip content={<Highlight type="bold" text={tooltip} />}>
                <Icon icon="Info" size="large" color="tealDark" />
              </Tooltip>
            </styled.SectionTitleTooltip>
          )}
        </styled.SectionTitle>
      )}
      {children}
    </styled.Section>
  );
};
